// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32DsV","rootMobile":"styles_rootMobile__nb25Y"};